import { render, staticRenderFns } from "./CorporateEdit.vue?vue&type=template&id=53fd8b71&scoped=true"
import script from "./CorporateEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd8b71",
  null
  
)

export default component.exports